import {scrollIntoView} from "../Helpers/scrollTo";

export const scrollListener = (callback: (this:Window, ev: Event) => any) => {
	window.addEventListener("scroll", callback);
}
